import React from 'react';
import { Container, Title, Paper, Text } from '@mantine/core';

export const ApiKeysPage: React.FC = () => {
  return (
    <Container size="xl">
      <Paper withBorder p="xl">
        <Title order={2} mb="md">API Keys</Title>
        <Text c="dimmed">Manage API keys for external integrations.</Text>
      </Paper>
    </Container>
  );
};